import { render } from "./DsHome.vue?vue&type=template&id=b0c3dd7a"
import script from "./DsHome.vue?vue&type=script&lang=js"
export * from "./DsHome.vue?vue&type=script&lang=js"

import "./home.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__